var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 209 209",
    style: {
      enableBackground: "new 0 0 209 209"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#333333;}\n\t.st3{fill:#888888;}\n\t.st4{fill:none;stroke:#333333;stroke-linecap:round;}\n\t.st5{fill:none;stroke:#555555;stroke-linecap:round;}\n\t.st6{fill:none;stroke:#AAAAAA;stroke-linecap:round;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 209,
    height: 209
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 102.7,
    cy: 104.2,
    r: 95.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.5,38.7l2.9-3.5c-0.1,0.1-0.2,0.2-0.4,0.2c-0.2,0.1-0.4,0.1-0.7,0.1c-0.5,0-1-0.1-1.4-0.4 c-0.4-0.3-0.8-0.6-1.1-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.2-1.2,0.5-1.7s0.7-0.9,1.2-1.1c0.5-0.3,1.1-0.4,1.7-0.4 c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.5,1.1,0.5,1.7c0,0.7-0.1,1.4-0.4,1.9c-0.2,0.5-0.5,0.9-0.8,1.3 l-2.4,2.9H97.5z M99.7,34.1c0.3,0,0.6-0.1,0.9-0.2c0.3-0.2,0.5-0.4,0.6-0.6c0.2-0.3,0.2-0.5,0.2-0.9c0-0.3-0.1-0.6-0.2-0.9 c-0.2-0.3-0.4-0.5-0.6-0.6c-0.3-0.2-0.5-0.2-0.9-0.2c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.2-0.5,0.4-0.6,0.6c-0.1,0.3-0.2,0.5-0.2,0.9 c0,0.3,0.1,0.6,0.2,0.9c0.2,0.3,0.4,0.5,0.6,0.6C99.1,34,99.4,34.1,99.7,34.1z M106.3,32.1h1.3l2.5,6.6h-1.3l-0.5-1.4h-2.6 l-0.5,1.4h-1.3L106.3,32.1z M106.1,36.1h1.8l-0.9-2.6h0L106.1,36.1z M117.4,32.1v6.6h-1.2v-4.2l0.1-1l-0.2,1.1l-1.3,3.6h-1.2 l-1.3-3.6l-0.2-1.1l0.1,1v4.2h-1.2v-6.6h1.7l1.5,4.7l0.1,0.4l0.1-0.4l1.5-4.7H117.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M43.8,51.6c0.4,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.4,0.8,0.8c0.2,0.3,0.3,0.7,0.3,1.2c0,0.4-0.1,0.8-0.3,1.2 c-0.2,0.3-0.5,0.6-0.9,0.8c-0.4,0.2-0.8,0.3-1.2,0.3c-0.4,0-0.9-0.1-1.2-0.3c-0.4-0.2-0.7-0.5-0.9-0.8c-0.2-0.4-0.3-0.8-0.3-1.2 c0-0.5,0.1-1,0.3-1.3c0.2-0.4,0.4-0.7,0.6-1l1.7-2.1h1.5L43,51.9c0.1-0.1,0.1-0.1,0.3-0.2S43.6,51.6,43.8,51.6z M43.5,55.1 c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.3,0.4-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6s-0.3-0.3-0.4-0.4 c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.3-0.4,0.4s-0.2,0.4-0.2,0.6c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.2,0.3,0.3,0.4,0.4C43,55,43.2,55.1,43.5,55.1z M50.5,50.7h1l2,5.3h-1.1L52,54.9h-2.1L49.5,56h-1.1L50.5,50.7z M50.2,54h1.5 l-0.7-2h0L50.2,54z M59.3,50.7V56h-1v-3.4l0-0.8l-0.2,0.9l-1,2.9h-1l-1-2.9l-0.2-0.9l0,0.8V56h-1v-5.3h1.4l1.2,3.8l0.1,0.4 l0.1-0.4l1.2-3.8H59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.8,150.4l-1.1,0.6v-1.2l1.7-1h0.6v6.6h-1.2V150.4z M50.5,149.8c-0.2,0-0.5,0.1-0.6,0.2 c-0.2,0.1-0.3,0.2-0.5,0.4c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.2-0.1,0.2l-1.1-0.5c0,0,0-0.1,0.1-0.2 c0.1-0.1,0.1-0.3,0.3-0.4c0.1-0.2,0.3-0.3,0.5-0.5c0.2-0.2,0.4-0.3,0.7-0.4c0.3-0.1,0.6-0.2,1-0.2c0.4,0,0.8,0.1,1.1,0.2 c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.4,0.4,0.7c0.1,0.2,0.1,0.5,0.1,0.8c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.3-0.3,0.5-0.5,0.8 c-0.2,0.3-0.4,0.5-0.6,0.7c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.4,0.3-0.5,0.4c-0.1,0.1-0.2,0.2-0.3,0.2h2.7v1.1h-4.6v-1 c0.1-0.1,0.2-0.1,0.4-0.3c0.2-0.1,0.4-0.3,0.7-0.5c0.3-0.2,0.5-0.4,0.8-0.7c0.3-0.2,0.5-0.5,0.8-0.7c0.2-0.3,0.4-0.5,0.6-0.7 c0.1-0.2,0.2-0.5,0.2-0.7c0-0.4-0.1-0.6-0.3-0.8C51.1,149.8,50.8,149.8,50.5,149.8z M57.5,150.1h1l2,5.3h-1.1l-0.4-1.1h-2.1 l-0.4,1.1h-1.1L57.5,150.1z M57.2,153.4h1.5l-0.7-2h0L57.2,153.4z M66.3,150.1v5.3h-1V152l0-0.8l-0.2,0.9l-1,2.9h-1l-1-2.9 l-0.2-0.9l0,0.8v3.4h-1v-5.3h1.4l1.2,3.8l0.1,0.4l0.1-0.4l1.2-3.8H66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160,100.1c0-0.2,0.1-0.3,0.3-0.6c0.1-0.2,0.3-0.4,0.6-0.6c0.2-0.2,0.6-0.4,0.9-0.5c0.4-0.1,0.8-0.2,1.3-0.2 c0.6,0,1.1,0.1,1.5,0.3c0.4,0.2,0.8,0.5,1,0.9c0.2,0.4,0.4,0.8,0.4,1.3c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.7 c-0.2,0.2-0.4,0.3-0.6,0.3c0.2,0,0.5,0.1,0.7,0.3c0.2,0.2,0.5,0.4,0.6,0.7s0.3,0.7,0.3,1.1c0,0.6-0.1,1.1-0.4,1.5 c-0.3,0.4-0.7,0.8-1.2,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.2-0.1-1.7-0.3c-0.5-0.2-0.8-0.5-1.1-0.8c-0.3-0.3-0.5-0.7-0.5-1 l1.6-0.8c0.1,0.2,0.2,0.4,0.3,0.6c0.2,0.2,0.3,0.4,0.6,0.6c0.2,0.1,0.5,0.2,0.8,0.2c0.3,0,0.6-0.1,0.8-0.2 c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.2,0.2-0.5,0.2-0.8c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.3-0.3-0.6-0.4c-0.2-0.1-0.5-0.1-0.8-0.1h-0.2 v-1.3h0.2c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.6-0.3-0.9c-0.2-0.2-0.6-0.4-1-0.4 c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.2-0.1,0.3L160,100.1z M167.4,101.1h2.2 c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.6,0.4,0.8,0.7c0.2,0.3,0.3,0.7,0.3,1.1c0,0.5-0.1,0.8-0.3,1.1c-0.2,0.3-0.5,0.5-0.8,0.7 c-0.3,0.2-0.7,0.2-1.1,0.2h-0.9v2.5h-1.2V101.1z M168.6,104.1h0.6c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.2,0.5-0.3 c0.1-0.2,0.2-0.4,0.2-0.6c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.3c-0.2-0.1-0.4-0.1-0.6-0.1h-0.6V104.1z M179.4,101.1v6.6 h-1.2v-4.2l0.1-1l-0.2,1.1l-1.3,3.6h-1.2l-1.3-3.6l-0.2-1.1l0.1,1v4.2h-1.2v-6.6h1.7l1.5,4.7l0.1,0.4l0.1-0.4l1.5-4.7H179.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.9,100.1c0-0.2,0.1-0.3,0.3-0.6c0.1-0.2,0.3-0.4,0.6-0.6c0.2-0.2,0.6-0.4,0.9-0.5c0.4-0.1,0.8-0.2,1.3-0.2 c0.6,0,1.1,0.1,1.5,0.3c0.4,0.2,0.8,0.5,1,0.9c0.2,0.4,0.4,0.8,0.4,1.3c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.7 c-0.2,0.2-0.4,0.3-0.6,0.3c0.2,0,0.5,0.1,0.7,0.3c0.2,0.2,0.5,0.4,0.6,0.7s0.3,0.7,0.3,1.1c0,0.6-0.1,1.1-0.4,1.5 c-0.3,0.4-0.7,0.8-1.2,1.1c-0.5,0.3-1.1,0.4-1.7,0.4c-0.7,0-1.2-0.1-1.7-0.3c-0.5-0.2-0.8-0.5-1.1-0.8c-0.3-0.3-0.5-0.7-0.5-1 l1.6-0.8c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.3,0.4,0.6,0.6c0.2,0.1,0.5,0.2,0.8,0.2c0.3,0,0.6-0.1,0.8-0.2 c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.2,0.2-0.5,0.2-0.8c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.3-0.3-0.6-0.4c-0.2-0.1-0.5-0.1-0.8-0.1h-0.2 v-1.3h0.2c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.6-0.4-0.9c-0.2-0.2-0.6-0.4-1-0.4 c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.2-0.1,0.3L26.9,100.1z M36.3,101.1h1.3 l2.5,6.6h-1.3l-0.5-1.4h-2.6l-0.5,1.4h-1.3L36.3,101.1z M36.1,105.1h1.8l-0.9-2.6h0L36.1,105.1z M47.4,101.1v6.6h-1.2v-4.2l0.1-1 l-0.2,1.1l-1.3,3.6h-1.2l-1.3-3.6l-0.2-1.1l0.1,1v4.2h-1.2v-6.6h1.7l1.5,4.7l0.1,0.4l0.1-0.4l1.5-4.7H47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.6,176.7l2.9-3.5c-0.1,0.1-0.2,0.2-0.4,0.2c-0.2,0.1-0.4,0.1-0.7,0.1c-0.5,0-1-0.1-1.4-0.4 c-0.4-0.3-0.8-0.6-1.1-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.2-1.2,0.5-1.7c0.3-0.5,0.7-0.9,1.2-1.1c0.5-0.3,1.1-0.4,1.7-0.4 c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.5,1.1,0.5,1.7c0,0.7-0.1,1.4-0.4,1.9c-0.2,0.5-0.5,0.9-0.8,1.3 l-2.4,2.9H98.6z M100.8,172.1c0.3,0,0.6-0.1,0.9-0.2c0.3-0.2,0.5-0.4,0.6-0.6c0.2-0.3,0.2-0.5,0.2-0.9c0-0.3-0.1-0.6-0.2-0.9 c-0.2-0.3-0.4-0.5-0.6-0.6c-0.3-0.2-0.5-0.2-0.9-0.2c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.2-0.5,0.4-0.6,0.6c-0.1,0.3-0.2,0.5-0.2,0.9 c0,0.3,0.1,0.6,0.2,0.9c0.2,0.3,0.4,0.5,0.6,0.6C100.2,172,100.5,172.1,100.8,172.1z M105.4,170.1h2.2c0.4,0,0.8,0.1,1.1,0.2 c0.3,0.1,0.6,0.4,0.8,0.7c0.2,0.3,0.3,0.7,0.3,1.1c0,0.5-0.1,0.8-0.3,1.1c-0.2,0.3-0.5,0.5-0.8,0.7c-0.3,0.2-0.7,0.2-1.1,0.2h-1 v2.5h-1.2V170.1z M106.6,173.1h0.6c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.2,0.5-0.3s0.2-0.4,0.2-0.6c0-0.3-0.1-0.5-0.2-0.6 c-0.1-0.1-0.3-0.3-0.5-0.3c-0.2-0.1-0.4-0.1-0.6-0.1h-0.6V173.1z M117.4,170.1v6.6h-1.2v-4.2l0.1-1l-0.2,1.1l-1.3,3.6h-1.2 l-1.3-3.6l-0.2-1.1l0.1,1v4.2h-1.2v-6.6h1.7l1.5,4.7l0.1,0.4l0.1-0.4l1.5-4.7H117.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 104.7,
    y1: 14.2,
    x2: 104.7,
    y2: 20.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 104.7,
    y1: 187.2,
    x2: 104.7,
    y2: 193.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 193.7,
    y1: 104.2,
    x2: 187.7,
    y2: 104.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 20.7,
    y1: 104.2,
    x2: 14.7,
    y2: 104.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 40.6,
    y1: 40.4,
    x2: 42.7,
    y2: 42.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 165.6,
    y1: 164.4,
    x2: 167.7,
    y2: 166.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 167.7,
    y1: 40.1,
    x2: 165.6,
    y2: 42.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 43.7,
    y1: 165.1,
    x2: 41.6,
    y2: 167.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 60.1,
    y1: 25.6,
    x2: 61.6,
    y2: 28.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 146.7,
    y1: 178.9,
    x2: 148.2,
    y2: 181.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 182.5,
    y1: 59.9,
    x2: 179.9,
    y2: 61.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 29.2,
    y1: 146.5,
    x2: 26.6,
    y2: 147.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 79.9,
    y1: 17.4,
    x2: 80.7,
    y2: 20.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 127.5,
    y1: 186.9,
    x2: 128.3,
    y2: 189.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 190.6,
    y1: 79.9,
    x2: 187.7,
    y2: 80.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 21.1,
    y1: 127.4,
    x2: 18.2,
    y2: 128.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 128.9,
    y1: 17.7,
    x2: 128,
    y2: 20.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 79.7,
    y1: 186.8,
    x2: 78.9,
    y2: 189.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 189.9,
    y1: 129.3,
    x2: 187,
    y2: 128.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 20.8,
    y1: 80.1,
    x2: 18,
    y2: 79.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 150.4,
    y1: 27.3,
    x2: 148.9,
    y2: 29.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 58.7,
    y1: 177.6,
    x2: 57.1,
    y2: 180.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 180.1,
    y1: 150.9,
    x2: 177.5,
    y2: 149.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 29.8,
    y1: 59.2,
    x2: 27.3,
    y2: 57.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.8,51l-1.1,0.6v-1.2l1.7-1h0.6V56h-1.2V51z M149.5,50.3c-0.2,0-0.5,0.1-0.6,0.2c-0.2,0.1-0.3,0.2-0.5,0.4 s-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.2-0.1,0.2l-1.1-0.5c0,0,0-0.1,0.1-0.2c0.1-0.1,0.1-0.3,0.3-0.4c0.1-0.2,0.3-0.3,0.5-0.5 c0.2-0.2,0.4-0.3,0.7-0.4c0.3-0.1,0.6-0.2,1-0.2c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.4,0.4,0.7 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.3-0.3,0.5-0.5,0.8c-0.2,0.3-0.4,0.5-0.6,0.7c-0.2,0.2-0.4,0.4-0.6,0.6 c-0.2,0.2-0.4,0.3-0.5,0.4c-0.1,0.1-0.2,0.2-0.3,0.2h2.7V56h-4.6v-1c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.1,0.4-0.3,0.7-0.5 s0.5-0.4,0.8-0.7c0.3-0.2,0.5-0.5,0.8-0.7c0.2-0.3,0.4-0.5,0.6-0.7c0.1-0.2,0.2-0.5,0.2-0.7c0-0.4-0.1-0.6-0.3-0.8 C150,50.4,149.8,50.3,149.5,50.3z M154.8,50.7h1.8c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.5,0.3,0.6,0.5c0.2,0.2,0.2,0.5,0.2,0.9 c0,0.4-0.1,0.7-0.2,0.9c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.1-0.6,0.2-0.9,0.2h-0.8v2h-1V50.7z M155.8,53.2h0.5c0.2,0,0.4,0,0.5-0.1 c0.2-0.1,0.3-0.1,0.4-0.3s0.1-0.3,0.1-0.5c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.1-0.3-0.1-0.5-0.1h-0.5V53.2z  M164.4,50.7V56h-1v-3.4l0-0.8l-0.2,0.9l-1,2.9h-1l-1-2.9l-0.2-0.9l0,0.8V56h-1v-5.3h1.4l1.2,3.8l0.1,0.4l0.1-0.4l1.2-3.8H164.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.7,153.6c0.4,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.4,0.8,0.8c0.2,0.3,0.3,0.7,0.3,1.2c0,0.4-0.1,0.8-0.3,1.2 c-0.2,0.3-0.5,0.6-0.9,0.8c-0.4,0.2-0.8,0.3-1.2,0.3c-0.4,0-0.9-0.1-1.2-0.3c-0.4-0.2-0.7-0.5-0.9-0.8c-0.2-0.4-0.3-0.8-0.3-1.2 c0-0.5,0.1-1,0.3-1.3c0.2-0.4,0.4-0.7,0.6-1l1.7-2.1h1.5l-2.1,2.5c0.1-0.1,0.1-0.1,0.3-0.2C148.4,153.7,148.5,153.6,148.7,153.6z  M148.4,157.1c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.3,0.4-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6s-0.3-0.3-0.4-0.4 c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.3-0.4,0.4s-0.2,0.4-0.2,0.6c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.2,0.3,0.3,0.4,0.4C148,157,148.2,157.1,148.4,157.1z M153.8,152.7h1.8c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.5,0.3,0.6,0.5 c0.2,0.2,0.2,0.5,0.2,0.9c0,0.4-0.1,0.7-0.2,0.9c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.1-0.6,0.2-0.9,0.2h-0.8v2h-1V152.7z  M154.8,155.2h0.5c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.1,0.4-0.3s0.1-0.3,0.1-0.5c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.2-0.4-0.3 c-0.1-0.1-0.3-0.1-0.5-0.1h-0.5V155.2z M163.4,152.7v5.3h-1v-3.4l0-0.8l-0.2,0.9l-1,2.9h-1l-1-2.9l-0.2-0.9l0,0.8v3.4h-1v-5.3h1.4 l1.2,3.8l0.1,0.4l0.1-0.4l1.2-3.8H163.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.7398982cfe35ce8cbc35d6447462d827.svg";
export { ForwardRef as ReactComponent };